import React from "react";
import { PENDING_BILLING_TYPE } from "../../../models/constants";

export default function ItemType({ 
  type,
}) {
  const getClassName = (itemType) => {
    switch (itemType) {
      case 'appointment':
        return 'badge badge-primary';
      case 'prescription':
        return 'badge badge-success';
      case 'certificate':
        return 'badge badge-warning';
      default:
        return 'badge badge-secondary';
    }
  };

  const getIcon = (itemType) => {
    switch (itemType) {
      case 'appointment':
        return <i className="fas fa-calendar-check mr-1" aria-hidden="true" />;
      case 'prescription':
        return <i className="fas fa-prescription-bottle mr-1" aria-hidden="true" />;
      case 'certificate':
        return <i className="fas fa-file mr-1" aria-hidden="true" />;
      default:
        return <i className="fas fa-question mr-1" aria-hidden="true" />;
    }
  };

  return (
    <span className={getClassName(type)}>
      {getIcon(type)}
      {PENDING_BILLING_TYPE[type] || type}
    </span>
  );
}
